import { Component, OnInit, TemplateRef, viewChild, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { DynamictableComponent } from 'src/app/shared/dynamictable/dynamictable.component';
import { MatDialog } from '@angular/material/dialog';
import { CommonModule, formatDate } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ApprovalDashBoardService } from "src/app/services/approval-dashboard/approval-dashboard.service"
import Swal from 'sweetalert2';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { BillingAdjustmentDetails, InvoiceDetails } from 'src/app/Models/invoiceDetails';
import { AuthService } from 'src/app/services/auth/auth.service';
import { saveAs } from "file-saver";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup,FormsModule, Validators,ReactiveFormsModule, FormControl } from '@angular/forms';
import { MatError } from '@angular/material/form-field';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { BillingAdjustmentStatusEnumDisplay } from 'src/utilities';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MsalService } from '@azure/msal-angular';
import { BulkRequestService } from 'src/app/services/bulk-request/bulk-request.service';
import { DateRangeErrorStateMatcher } from 'src/app/approval-history/approval-history/approval-history.component';
import { BillingAdjustmentStatusEnum, dateRangeValidator, formatDateforBAT, FilterDto } from 'src/utilities';
import { SharedModule } from 'src/app/shared/shared.module';
import { SpinnerService } from 'src/app/services/spinner/spinner.service';



@Component({
    selector: 'app-bulk-request-gbs-history',
    imports: [FormsModule, MatDatepickerModule, MatSelectModule, MatError, MatNativeDateModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, DynamictableComponent, CommonModule, MatProgressSpinnerModule, NgxSpinnerModule, MatTableModule, SharedModule],
    templateUrl: './bulk-request-gbs-history.component.html',
    styleUrl: './bulk-request-gbs-history.component.scss'
})
export class BulkRequestGbsHistoryComponent  implements OnInit{


  @ViewChild(DynamictableComponent) dynamicTable: DynamictableComponent; // Reference to dynamic table for pagination control
  selectedData: any;
  isGoodWillRequest: boolean = false;
  chooseDialogRef: any;
  detailData: any[] = [];
  isLoader: boolean = true;
  isDetailView = false;
  dateForm: FormGroup;
  matcher = new DateRangeErrorStateMatcher();
  startDateInvalid: boolean = false;
  endDateInvalid: boolean = false;
  statusFilter: string = '';
  allRequestList: any[] = []; // holds all unfiltered data
    @ViewChild('detailsTemplate') detailsTemplate: TemplateRef<any>;
detailsModalRef: any;


  // ✅ Used for master table display
  readonly mainTableFieldMapping = [
    { label: 'Adj Req Id', propertyName: 'detailedAdjSubId' },
    { label: 'Requested Date', propertyName: 'adjRequestDate' },
    { label: 'Billing Site', propertyName: 'billingSite' },
    { label: '#MMS', propertyName: 'mms' },
    { label: 'Customer Name', propertyName: 'custName' },
    { label: 'Amount', propertyName: 'totalCorrectCharges' },
    {label:'Check Request',propertyName:'checkRequest'},
    { label: 'Adjustment Type', propertyName: 'brAdjType' },
    { label: 'AE/Sales Contact', propertyName: 'ae' },
    { label: 'Remit Address', propertyName: 'remitAddress' },
    {label:'Requestor',propertyName:'requestor'},
    {label:'Status',propertyName:'statusDesc'},
    {label:'Invoice Number',propertyName:'invoiceNumber'},
    {label:'Statment Number',propertyName:'statementNumber'},
    // {label:'GBS Remarks',properyName:'gbsRemarks'},
    // {label:'GBS Status',propertyName:'gbsStatus'},
    //{label:'MI Remarks',propertyName:'rejectionReason'},
    
       {
      label: 'Action', propertyName: 'icon',
      icons: [
      { toolTip: 'View Statement Details', icon: 'remove_red_eye', callFrom: 'viewDetails' },
      { toolTip: 'Download Files', icon: 'download' , callFrom:'download'},
      ]
    }
  ];

  // ✅ Used for detail table display
  readonly detailTableFieldMapping = [
    { label: 'Adj Req Id', propertyName: 'adjReqId' },
    { label: 'Total Customers', propertyName: 'customerCount' },
    { label: 'Adjustment Type', propertyName: 'brAdjType' },
    { label: 'Description', propertyName: 'descriptionComment' },
    { label: 'Amount', propertyName: 'adjNetAmount' },
    { label: 'Special Instructions', propertyName: 'specialInstructions' },
    { label: 'Requested Date', propertyName: 'adjRequestDate' },
    { label: 'Requester', propertyName: 'requestor' },
    //{ label: 'MI Remarks', propertyName: 'rejectionReason' }
  ];
  readonly mainRequestInfo = [
    { label: 'Adj Req Id', propertyName: 'detailedAdjSubId' },
    { label: 'Requested Date', propertyName: 'adjRequestDate' },
    { label: 'Billing Site', propertyName: 'billingSite' },
    { label: '#MMS', propertyName: 'mms' },
    { label: 'Customer Name', propertyName: 'custName' },
    { label: 'Amount', propertyName: 'totalCorrectCharges' },
    {label:'Check Request',propertyName:'checkRequest'},
    { label: 'Adjustment Method', propertyName: 'adjustmentMethod' },
    { label: 'AE/Sales Contact', propertyName: 'ae' },
    { label: 'Remit Address', propertyName: 'remitAddress' },
  { label: 'MI Status', propertyName: 'status' },
    { label: 'Actioned By (MI)', propertyName: 'approver' },
    { label: 'MI Remarks', propertyName: 'rejectionReason' },
    { label: 'GBS Status', propertyName: 'gbsStatus' },
    { label: 'Actioned By (GBS)', propertyName: 'gbsApprover' },
    { label: 'GBS Remarks', propertyName: 'reason' },
  ];
 invoiceDataSource = new MatTableDataSource<InvoiceDetails>([]);
  checked: boolean = true;
  dataSource = new MatTableDataSource<BillingAdjustmentDetails>([]);
  isAccepted: boolean = true;
  firstFormGroup: FormGroup;
  panels: any[] = [];
  isLoading: boolean = false;
  totalCount: number = 0; // Add total count for pagination
  pageSize: number = 20; // Dynamic page size property 
  currentPageIndex: number = 1; // Track current page for proper pagination display
  currentAppliedFilters: FilterDto[] = []; // Track filters used in current view
  currentStartDate: string | null = null; // Store current start date filter
  currentEndDate: string | null = null; // Store current end date filter
  currentStatusIds: number[] = [6, 7, 8, 9, 10, 11, 13]; // Store current status filter

  validateDateRange() {
    const startDate = this.dateForm.get('startDate')?.value;
    const endDate = this.dateForm.get('endDate')?.value;
    this.startDateInvalid = false;
    this.endDateInvalid = false;
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);
      if (start > end) {
        this.startDateInvalid = true;
        this.endDateInvalid = true;
      }
    }
  }

  constructor(private dialog: MatDialog,
    private modalService: BsModalService,
    private approvalDashBoardService: ApprovalDashBoardService,
    private authService: AuthService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private spinner: SpinnerService,
    private bulkRequestService: BulkRequestService,
  ) {
   }

 ngOnInit(): void {
    this.dateForm = this.fb.group({
      startDate: null,
      endDate: null,
      statusFilter: ['0']
    }, { validator: dateRangeValidator });
    this.dateForm.valueChanges.subscribe(() => {
      this.validateDateRange();
    });
   this.getAdjustmentDetails(1, 20); // Initialize with pagination parameters
  }
 

   getAdjustmentDetails(pageIndex: number = 1, pageSize: number = 20, filters: FilterDto[] = [], isRefresh: boolean = false)
  {    

    if (isRefresh) {
      pageIndex = 1;
      pageSize = 20;
      this.pageSize = 20;
      this.currentAppliedFilters = [];
      this.currentStartDate = null;
      this.currentEndDate = null;
      this.currentStatusIds = [6, 7, 8, 9, 10, 11, 13];
      this.dateForm.patchValue({ statusFilter: '0' });
      filters = [];
    }
    
    const isFilterChange = filters.length > 0;
    const isPaginationChange = filters.length === 0 && !isRefresh;
    
    
    if (isPaginationChange && this.currentAppliedFilters.length > 0) {
      filters = [...this.currentAppliedFilters];
    }
    
    if (isFilterChange) {      pageIndex = 1;
      this.currentAppliedFilters = [...filters];
    }
    
    // Update pageSize
    this.pageSize = pageSize;
    
        this.getAdjustmentDetailsWithDateFilters(pageIndex, pageSize, this.currentStartDate, this.currentEndDate, this.currentStatusIds, filters);
  }

  private getAdjustmentDetailsWithDateFilters(pageIndex: number = 1, pageSize: number = 20, startDate: string | null = null, endDate: string | null = null, statusIds: number[] = [6, 7, 8, 9, 10, 11, 13], filters: FilterDto[] = [])
  {
    
    this.spinner.showSpinner();    
    this.isLoader = true;
    
    let obj : any ={
      StartDate : startDate,
      EndDate: endDate,
      StatusId: statusIds,
      UserId: null,
      IsFromHistory: false,
      PageNumber: pageIndex,
      PageSize: pageSize,
      filters: filters.map(f => ({
        column: f.column,
        operator: f.operator || 'contains',
        value: f.value?.toString() || '', 
      }))
    }
    
    
    const notYetStatuses = [1,2,3,4,5,14,15];
    this.bulkRequestService.getBulkBillingAdjustmentForGBS(obj).subscribe({
      next: response => {
        
        const data = response.data || response;
        const totalFromBackend = response.totalCount || response.TotalCount || data.length;        
        this.dataSource.data = data;
        this.allRequestList = data;
        this.totalCount = totalFromBackend;
        this.pageSize = pageSize;
        this.currentPageIndex = pageIndex;
        this.dataSource.data.forEach(x => {
          x.adjRequestDate = formatDate(x.adjRequestDate,'MM/dd/yyyy', "en-US");
          x.statusDesc = x.statusId == 5 ?  BillingAdjustmentStatusEnumDisplay[7] :  BillingAdjustmentStatusEnumDisplay[x.statusId];
          x.gbsStatus = x.isGBSNMF
          ? BillingAdjustmentStatusEnumDisplay[BillingAdjustmentStatusEnum.GBSNeedMoreInformation] :
           notYetStatuses.includes(x.statusId) ? '--' : BillingAdjustmentStatusEnumDisplay[x.statusId];
        if (
        (x.gbsStatus === 'GBS Need More Information' && x.statusId !== BillingAdjustmentStatusEnum.Submitted ) ||
        (x.gbsStatus !== '--' && x.gbsStatus !== 'GBS Need More Information')
      ) {
        x.status = BillingAdjustmentStatusEnumDisplay[BillingAdjustmentStatusEnum.MIApproved];
      } else {

        if(x.statusId==1){
          x.status = '--'
        }else{
          x.status = BillingAdjustmentStatusEnumDisplay[x.statusId];
        }             
      }
        });
        
        this.isLoader = false;
        this.spinner.hideSpinner();
        
        this.updatePaginatorState();
        
      },
      error: (error) => {
        console.error('Bulk GBS History: API call failed', error);
        this.spinner.hideSpinner();
        this.isLoader = false;
        this.toastr.error('Failed to load bulk GBS history data. Please try again.', 'Error');
      }
    })
  }
  openAcceptOrRejectDialog(e) {
    this.selectedData = e.details;
     if (e.callFrom === 'download') {
      if(e.details.isFileUploaded)
      {
        this.spinner.showSpinner();
        this.approvalDashBoardService.DownloadUploadedFiles(e.details.adjReqId)
          .subscribe({
            next: data => {
              const filename = `AdjustmentRequest_${e.details.adjReqId}.zip`;  
              const blob = new Blob([data], { type: 'application/zip' });
              saveAs(blob, filename);
              this.spinner.hideSpinner();
              this.toastr.success('File Downloaded Successfully', 'Success');
            },
            error: () => {
              this.spinner.hideSpinner();
              this.toastr.error('Error downloading file', 'Error');
            }
          });
      }
else{
        this.toastr.warning('No Files Uploaded', 'warning');
      }
    }
 else if (e.callFrom === 'viewDetails') {
  this.isDetailView = true;
  this.loadDetailsByAdjReqId(e.details.detailedAdjSubId);
  // this.loadDetailsByDetailsId(e.details.detailedAdjSubId);

   this.detailsModalRef = this.modalService.show(this.detailsTemplate, {
    backdrop: true,
    class: 'modal-xl'
  });
}

  }

 loadDetailsByAdjReqId(detailedAdjSubId: string): void{
  this.spinner.showSpinner();

const selectedRow = this.dataSource.data.find(x => x.detailedAdjSubId === detailedAdjSubId);
  if (selectedRow) {
    this.detailData = [selectedRow]; // Wrap in array for table binding
    this.invoiceDataSource.data = this.detailData;
  } else {
    this.detailData = [];
    this.invoiceDataSource.data = [];
  }
  this.spinner.hideSpinner();
}


closeDetailsPopup() {
  if (this.detailsModalRef) {
    this.detailsModalRef.hide();
  }
  this.isDetailView = false;
}

onSubmit(filters: FilterDto[] = []): void {
  this.dateForm.markAllAsTouched();
  if (this.dateForm.invalid) return;
  this.currentPageIndex = 1;
  

  const startDate = this.dateForm.get('startDate')?.value;
  const endDate = this.dateForm.get('endDate')?.value;
  const selectedStatus = +this.dateForm.get('statusFilter')?.value;

  const formattedStartDate = formatDateforBAT(startDate);
  const formattedEndDate = formatDateforBAT(endDate, true);
  

  var statusIds = selectedStatus == 0 ? 
    [6, 7, 8, 9, 10, 11, 13] : [selectedStatus];

  this.currentStartDate = formattedStartDate;
  this.currentEndDate = formattedEndDate;
  this.currentStatusIds = statusIds;

  this.getAdjustmentDetailsWithDateFilters(1, this.pageSize, formattedStartDate, formattedEndDate, statusIds, filters);
}

  // Update paginator state to sync with current page
  private updatePaginatorState() {
    setTimeout(() => {
      if (this.dynamicTable && this.dynamicTable.paginator) {
        const paginatorPageIndex = Math.max(0, this.currentPageIndex - 1);
        
        this.dynamicTable.paginator.length = this.totalCount;
        this.dynamicTable.paginator.pageSize = this.pageSize;
        this.dynamicTable.paginator.pageIndex = paginatorPageIndex;
        
        const maxPages = Math.ceil(this.totalCount / this.pageSize);
        
        console.log('📊 Bulk GBS History: Updated paginator state:', {
          totalCount: this.totalCount,
          pageSize: this.pageSize,
          currentPageIndex: this.currentPageIndex,
          paginatorPageIndex: paginatorPageIndex,
          maxPages: maxPages,
          activeFilters: this.currentAppliedFilters.length
        });
      } else {
        console.warn('⚠️ Bulk GBS History: Paginator not available for state update');
      }
    }, 0);
  }

//   showTooltip = false;
//   tooltipSvg = `
//   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" width="200" height="200">
//     <text x="10" y="20" class="tooltip-text">$0 - $2,499:  Supervisor</text><br/>
//     <text x="10" y="40" class="tooltip-text">$0 - $4,999:  Manager</text><br/>
//     <text x="10" y="60" class="tooltip-text">$0 & above:  District Mgr/ Finance Director</text><br/>
//     <text x="10" y="80" class="tooltip-text">Any amount of goodwill request: Requires approval from MI Director of Finance</text>
//   </svg>
// `;
}


